import { render, staticRenderFns } from "./AddPartModal.vue?vue&type=template&id=227c9fbf&scoped=true"
import script from "./AddPartModal.vue?vue&type=script&lang=js"
export * from "./AddPartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c9fbf",
  null
  
)

export default component.exports